<template>
  <div style="border-bottom:1px solid #e3e3e3;">
    <label
      class="fntP"
      :class="isLeft ? 'NCACroa_cont01_file01' : 'NCACroa_cont01_file02'"
      :style="blockLabel ? { display: 'block' } : null"
    >
      <em
        class="disIb"
        :class="isLeft ? (showAlert ? 'padBS' : null) : 'moOnly'"
      >{{ question.title }} <span class="ico-must-astar"></span></em>
      <slot name="inner"></slot>
      <span
        class="NCACroa_fileBtn"
        :class="disabled || existFileData ? 'disabled' : null"
        :style="[
          hideBtn ? { display: 'none' } : null,
          disabled || existFileData ? null : { cursor: 'pointer' }
        ]"
        @click="clickFileUpload"
      >파일 업로드</span>
    </label>
    <input
      v-if="!existFileData"
      type="file"
      ref="attachment"
      accept=".png, .jpg, .pdf"
      style="display:none;"
      :name="`NCACroa_file_${question.sq_code}`"
      @change="addAttachment"
    >
    <div class="posRe" :style="hideBtn ? { display: 'none' } : null">
      <label
        class="NCACroa_cont01_file01 marTS NCAfile_remove"
        @click="downloadFile"
      >
        <input
          type="text"
          class="file_download"
          :style="existFileData ? { cursor: 'pointer' } : null"
          :title="data.original_name"
          :value="data.original_name"
          disabled
        />
      </label>
      <button class="posAb" style="right:0; top:6px; background:none;" @click="deleteAttachment" :style="!existFileData ? { display: 'none' } : null">
        <img src="../images/btn_close.png" alt="파일 삭제 버튼" />
      </button>
    </div>
    <slot name="outer"></slot>
  </div>
</template>

<script>
import { SURVEY, SET_LOADING } from '@/store/actions/survey'
import { mapState } from 'vuex'
import { validateFile, uploadFileToS3, deleteFileFromS3 } from '@/utils/fileUpload'
import axios from 'axios'

export default {
  name: 'SurveyAttachment',
  props: {
    isLeft: {
      type: Boolean,
      default: true,
    },
    question: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    showAlert: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    blockLabel: {
      type: Boolean,
      default: false
    },
    folderName: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(SURVEY, {
      aboUid: state => state.abo_uid,
      waveNumber: state => state.wave_number
    }),
    path() {
      return `survey/attachment/${this.waveNumber}/${this.aboUid}/${this.folderName}`;
    },
    existFileData() {
      return this.data.original_name && this.data.path;
    },
    fileExtension() {
      return this.data.original_name ? this.data.original_name.slice(this.data.original_name.lastIndexOf('.')) : '';
    },
    downloadUrl() {
      return this.existFileData ? `https://${process.env.AWS_BUCKET_NAME}/${this.data.path}/${this.data.original_name}` : '';
    },
    downloadFileName() {
      if(this.existFileData) {
        let filename = this.data.original_name.slice(0, this.data.original_name.lastIndexOf('.'));
        if(filename.length > 10) {
          filename = filename.slice(0, 9) + '...';
        }

        return filename + this.fileExtension;
      } else {
        return '';
      }
    }
  },
  methods: {
    clickFileUpload(e) {
      if(this.disabled || this.existFileData) return false;
      this.$refs.attachment.click();
    },
    async addAttachment($event) {
      const file = $event.target.files[0];
      if(!file) return;

      // 1. 파일 체크
      const err = validateFile(file);
      if(err) {
        alert(err);
        return;
      }
      
      // 2. 파일 정보 세팅
      const fileName = file.name.substring(0, file.name.lastIndexOf('.')).replace(' ', '_') + '_' + new Date().getTime() + file.name.substring(file.name.lastIndexOf('.'));
      const key = `${this.path}/${fileName}`; // S3 저장 경로(파일명 포함)
      // console.log('file key : ' + key);

      try {
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);
        // 3. 파일 S3 업로드
        await uploadFileToS3(key, file);

        // 4. 부모 컴포넌트에 uploaded 이벤트 emit
        this.$emit('upload:file', { original_name: fileName, path: this.path });
      } catch (error) {
        alert('잠시 후 다시 시도해주시길 바랍니다.');
        console.error('Upload Attachment ERROR!!', error.stack);
        return;
      } finally {
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
      }
    },
    async deleteAttachment() {
      // 파일 삭제 전 경고창
      if(!confirm('파일을 삭제하면 되돌릴 수 없습니다. 정말로 삭제하시겠습니까?')) {
        return;
      }

      this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);

      // 2. S3 파일 삭제
      try {
        const { sr_seq, sq_code } = this.data;
        if(sr_seq) {
          const { data } = await axios.post(`${process.env.AWS_GATEWAY_URL_V2}/survey/attachment/delete`, { files: [{sr_seq, sq_code}] });
          if(data.status !== 204) {
            alert('잠시 후 다시 시도해주시길 바랍니다.');  
            console.error(data.message);
            this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
            return;
          }
        }
        const response = await deleteFileFromS3(`${this.data.path}/${this.data.original_name}`);
        if(response.error) {
          alert('잠시 후 다시 시도해주시길 바랍니다.');  
          console.error('Delete Attachment ERROR!!', response.error);
          this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
          return;
        }
        this.$emit('delete:file');
      } catch (error) {
        alert('잠시 후 다시 시도해주시길 바랍니다.');
        console.error('Delete Attachment ERROR!!', error.stack);
      }

      this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
    },
    downloadFile(e) {
      e.preventDefault();
      if(e.target.value && this.downloadUrl) {
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);
        
        window.location.href = this.downloadUrl;

        setTimeout(() => { // 연속 파일 다운로드 클릭 시 버그 수정
          this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
        }, 500);
        return false;
      }
    }
  },
}
</script>

<style scoped>
input.file_download {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyAttachment.vue